import moment from 'moment'
import find from 'lodash/find'
import findIndex from 'lodash/findIndex'
import omit from 'lodash/omit'
import store from 'store2'
import { FormattedMessage } from 'react-intl'
import messages from './messages'
import { APP_LANGUAGE } from './localized-urls'

export function getToken() {
  return store('token')
}

export function removeToken() {
  return store.remove('token')
}

export function getLanguage() {
  let langPrefix = window.location.pathname.match(/^\/(de|fr|it|es|ach)\/?/)
  let lang = 'en'

  if(langPrefix) {
    if(langPrefix[0].search('ach') >= 0) {
      lang = 'ach'
    } else {
      lang = langPrefix[0].substr(1, 2)
    }
  }

  return lang
}

export function serializeData(params, keys = [], isArray = false) {
  const p = Object.keys(params).map(key => {
    let val = params[key]

    if(Object.prototype.toString.call(val) === '[object Object]' || Array.isArray(val)) {
      if(Array.isArray(params)) {
        keys.push('')
      } else {
        keys.push(key)
      }
      return serializeData(val, keys, Array.isArray(val))
    } else {
      let tKey = key

      if(keys.length > 0) {
        const tKeys = isArray ? keys : [...keys, key]
        tKey = tKeys.reduce((str, k) => { return str === '' ? k : `${str}[${k}]` }, '')
      }

      if(typeof val !== 'undefined') {
        return `${tKey}=${val}`
      }
    }
  }).join('&')
  keys.pop()
  return p
}

export function scrollTo(element, to, duration = 300) {
  if(duration <= 0) { return }
  let difference = to - element.scrollTop
  let perTick = difference / duration * 10

  setTimeout(function() {
    element.scrollTop = element.scrollTop + perTick
    if(element.scrollTop === to) { return }
    scrollTo(element, to, duration - 10)
  }, 10)
}

export function getRelativePos(elm) {
  const coords = getOffset(elm)
  const parentCoords = getOffset(elm.parentElement)

  return {
    top: coords.top - parentCoords.top,
    left: coords.left - parentCoords.left,
  }
}

export function calculateDiscountPercent(first, second) {
  return Math.round(100 - (first / second * 100))
}

export function parseQuery(url = document.location.search) {
  const qs = window.location.search.replace('?', '')
  const items = qs.split('&')
  // Consider using   reduce to create the data mapping
  return items.reduce((data, item) => {
    const splittedItem = item.split('=')
    const key = splittedItem[0]
    const value = splittedItem.length > 2 ? window.decodeURIComponent(splittedItem.slice(1).join('=')) : splittedItem[1]
    // Sometimes a query string can have multiple values
    // for the same key, so to factor that case in, you
    // could collect an array of values for the same key
    if(data[key] !== undefined) {
      // If the value for this key was not previously an
      // array, update it
      if(!Array.isArray(data[key])) {
        data[key] = [ data[key] ]
      }
      data[key].push(value)
    } else {
      data[key] = value
    }

    return data
  }, {})
}

export function setCookie(name, value, options = {}) {
  var expires = options.expires

  if(typeof expires === 'number' && expires) {
    var d = new Date()
    d.setTime(d.getTime() + expires * 1000)
    expires = options.expires = d
  }

  if(expires && expires.toUTCString) {
    options.expires = expires.toUTCString()
  }

  value = encodeURIComponent(value)

  var updatedCookie = `${name}=${value}`

  for(var propName in options) {
    updatedCookie += `;${propName}`
    var propValue = options[propName]
    if(propValue !== true) {
      updatedCookie += `=${propValue}`
    }
  }

  document.cookie = updatedCookie
}

export function getCookie(name) {
  let a = `; ${document.cookie}`.match(`;\\s*${name}=([^;]+)`)
  return a ? a[1] : ''
}

export function animate(draw, duration, callback) {
  var start = window.performance.now()

  window.requestAnimationFrame(function animate(time) {
    // определить, сколько прошло времени с начала анимации
    var timePassed = time - start

    // возможно небольшое превышение времени, в этом случае зафиксировать конец
    if(timePassed > duration) {
      timePassed = duration
    }

    // нарисовать состояние анимации в момент timePassed
    draw(timePassed)

    // если время анимации не закончилось - запланировать ещё кадр
    if(timePassed < duration) {
      window.requestAnimationFrame(animate)
    } else {
      if(callback) { callback() }
    }
  })
}

export function getOffset(el) {
  const bodyRect = document.body.getBoundingClientRect()
  const elemRect = el.getBoundingClientRect()
  const offsetLeft = elemRect.left - bodyRect.left
  const offsetTop = elemRect.top - bodyRect.top

  return { top: offsetTop, left: offsetLeft }
}

export function setStyle(element, propertyObject) {
  for(var property in propertyObject) {
    element.style[property] = propertyObject[property]
  }
}

export function generateQueryForTrip(trip, isWidget) {
  let query = '?'
  let queryParams = parseQuery()

  if(isWidget) {
    query = `?utm_campaign=WW-ALL-ALL-DI-Affiliates&utm_medium=widget&utm_content=${queryParams.popup ? 'search_modal' : 'search_iframe'}&`
  }

  if(queryParams.duration) {
    if(Array.isArray(queryParams.duration)) {
      queryParams.duration.map(function(val) {
        query += `duration=${val}&`
      })
    } else {
      query += `duration=${queryParams.duration}&`
    }
  }

  if(queryParams.harbours) {
    if(Array.isArray(queryParams.harbours)) {
      queryParams.harbours.map(function(val) {
        query += `harbours=${val}&`
      })
    } else {
      query += `harbours=${queryParams.harbours}&`
    }
  }

  if(queryParams.aid) {
    query += `utm_source=affiliate_${queryParams.aid}&aid=${queryParams.aid}&`

    if(queryParams.cid) {
      query += `cid=${queryParams.cid}&`
    }
  }

  if(trip) {
    query += `trip_id=${trip.id}&trip_date=${moment(trip.startDate).format('YYYY-MM-DD')}`
  }

  if(query === '?') {
    query = ''
  }

  return query
}

export function isValidEmail(email) {
  return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email)
}

export function isMobile() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
}

export function getTextFromInfo(id, category, option) {
  if(!window.info) { return '' }

  let element = window.info[category][option]
  let index = findIndex(element, function(val) {
    return val[0] === id
  })

  if(index !== -1) {
    return element[index][1]
  }
}

export function isStaff() {
  const user = store.get('user')

  return user && user.isStaff
}

export function findInObject(obj, id) {
  const index = findIndex(obj, {
    id,
  })
  return index !== -1
}

export function checkIsEditOrder() {
  const query = parseQuery()
  if(query.referrer && query.order_uuid) {
    sessionStorage.setItem('diviac.order_uuid', query.order_uuid)
    sessionStorage.setItem('diviac.referrer', query.referrer)

    window.location.href = '/checkout' + window.location.pathname
  }
}

export function setGuestParams(selectedParams, totalGuests) {
  const guestsNumber = totalGuests || selectedParams.totalGuests
  if(guestsNumber) {
    try {
      const guestSplit = [JSON.parse(selectedParams.guests_split)]
      // Update localstorage each time when user clicked on item
      const roomParams = {
        id: 'auto',
        rooms: selectedParams.rooms,
        divers: selectedParams.divers,
        nonDivers: selectedParams.nonDivers,
        students: selectedParams.students,
        totalGuests: guestsNumber,
        guests_split: guestSplit,
        details: guestSplit,
      }
      store('roomParams', roomParams)
    } catch (e) {
      console.log(e)
    }
  }
}

export function setAffiliateCookie() {
  const queryParams = parseQuery()
  const user = store.get('user')

  if((!user || (user && !user.affiliate && !user.isStaff)) && queryParams.aid) {
    const domain = (window.location.host.indexOf('padi.com') !== -1) ? 'padi.com' : window.location.host
    setCookie('padi_aid', queryParams.aid, {
      domain,
      path: '/',
      expires: 3600 * 24 * 90, /* 90days */
    })
    if(window.dataLayer) {
      let gtmObject = {
        affiliate_id: queryParams.aid,
        affiliate_type: 'Shop affiliate',
        user_type: 'Affiliate',
      }
      if(queryParams.cid) {
        gtmObject.affiliate_campaign = `${queryParams.cid}_${queryParams.campaign_title || 'No title'}`
        setCookie('padi_cid', queryParams.cid, {
          domain,
          path: '/',
          expires: 3600 * 24 * 90, /* 90days */
        })
      }
      window.dataLayer.push(gtmObject)
    }
  }
}

export function selectAffiliate(id) {
  const user = store.get('user')

  user.affiliate = find(user.affiliates, { memberNumber: id })

  store.set('user', user)
  window.location.reload()
}

export function generateAffiliateUrl() {
  let query = '?'
  const user = store.get('user')
  const affiliateIdText = document.getElementById('current-affiliate-id')
  const affiliateQueries = [
    'aid',
    'utm_campaign',
    'utm_source',
    'utm_medium',
    'utm_content',
  ]

  if(user.affiliates && !user.affiliate) {
    user.affiliate = user.affiliates[0]
  }

  if(!user.affiliate) {
    return
  }

  affiliateIdText.innerText = user.affiliate.memberNumber

  if(window.location.search) {
    const queryParams = parseQuery()
    const cleanedQueryParams = omit(queryParams, function(val, key) {
      return affiliateQueries.indexOf(key) !== -1
    })

    query += serializeData(cleanedQueryParams)
  }

  if(query.length > 1) {
    query += '&'
  }

  query += `aid=${user.affiliate.memberNumber}&utm_campaign=ww-all-all-affiliates-shops&utm_source=affiliate_${user.affiliate.memberNumber}&utm_medium=link&utm_content=direct`

  return window.location.origin + window.location.pathname + query
}

export const generateMonthPicker = (numberOfMonthes = 24, liveaboardPricingPage) => {
  let monthCount = moment().month()
  let time
  if(liveaboardPricingPage) {
    time = [{
      id: 'available',
      label: <FormattedMessage {...messages.showAvailable} />,
      from: moment().format('YYYY-MM-DD'),
      to: moment().add('30', 'd').format('YYYY-MM-DD'),
    }, {
      id: 'all',
      label: <FormattedMessage {...messages.showAll} />,
      from: moment().format('YYYY-MM-DD'),
      to: moment().add('30', 'd').format('YYYY-MM-DD'),
    }]
  } else {
    time = [{
      id: '30-days',
      label: <FormattedMessage {...messages.next30} />,
      from: moment().format('YYYY-MM-DD'),
      to: moment().add('30', 'd').format('YYYY-MM-DD'),
    }]
  }
  while(monthCount < numberOfMonthes + moment().month() + 1) {
    time.push({
      id: moment().month(monthCount).locale('en').format('MMM-YYYY'),
      from: moment().month(monthCount).subtract(0, 'months').startOf('month').format('YYYY-MM-DD'),
      to: moment().month(monthCount).subtract(0, 'months').endOf('month').format('YYYY-MM-DD'),
      label: moment().month(monthCount).locale(APP_LANGUAGE).format('MMMM YYYY'),
    })

    monthCount++
  }

  return time
}

export function compareObjects() {
  var i, l, leftChain, rightChain

  function compare2Objects(x, y) {
    var p

    // remember that NaN === NaN returns false
    // and isNaN(undefined) returns true
    if(isNaN(x) && isNaN(y) && typeof x === 'number' && typeof y === 'number') {
      return true
    }

    // Compare primitives and functions.
    // Check if both arguments link to the same object.
    // Especially useful on the step where we compare prototypes
    if(x === y) {
      return true
    }

    // Works in case when functions are created in constructor.
    // Comparing dates is a common scenario. Another built-ins?
    // We can even handle functions passed across iframes
    if((typeof x === 'function' && typeof y === 'function') ||
       (x instanceof Date && y instanceof Date) ||
       (x instanceof RegExp && y instanceof RegExp) ||
       (x instanceof String && y instanceof String) ||
       (x instanceof Number && y instanceof Number)) {
      return x.toString() === y.toString()
    }

    // At last checking prototypes as good as we can
    if(!(x instanceof Object && y instanceof Object)) {
      return false
    }

    if(x.isPrototypeOf(y) || y.isPrototypeOf(x)) {
      return false
    }

    if(x.constructor !== y.constructor) {
      return false
    }

    if(x.prototype !== y.prototype) {
      return false
    }

    // Check for infinitive linking loops
    if(leftChain.indexOf(x) > -1 || rightChain.indexOf(y) > -1) {
      return false
    }

    // Quick checking of one object being a subset of another.
    // todo: cache the structure of arguments[0] for performance
    for(p in y) {
      if(y.hasOwnProperty(p) !== x.hasOwnProperty(p)) {
        return false
      } else if(typeof y[p] !== typeof x[p]) {
        return false
      }
    }

    for(p in x) {
      if(y.hasOwnProperty(p) !== x.hasOwnProperty(p)) {
        return false
      } else if(typeof y[p] !== typeof x[p]) {
        return false
      }

      switch (typeof (x[p])) {
        case 'object':
        case 'function':

          leftChain.push(x)
          rightChain.push(y)

          if(!compare2Objects(x[p], y[p])) {
            return false
          }

          leftChain.pop()
          rightChain.pop()
          break

        default:
          if(x[p] !== y[p]) {
            return false
          }
          break
      }
    }

    return true
  }

  if(arguments.length < 1) {
    return true // Die silently? Don't know how to handle such case, please help...
    // throw "Need two or more arguments to compare";
  }

  for(i = 1, l = arguments.length; i < l; i++) {
    leftChain = [] // Todo: this can be cached
    rightChain = []

    if(!compare2Objects(arguments[0], arguments[i])) {
      return false
    }
  }

  return true
}

// check's if trip start date is earlier than N days from today
export function isLastMinuteBooking(date) {
  let days = 21
  let dateNow = moment()
  let tripStartDate = moment(date)

  return (tripStartDate.diff(dateNow, 'days') + 1) <= days
}
